module.exports = "https://r.zoocdn.com/_next/static/images/time-e1c867193368c08afaeb3661a8711f99.svg";